import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            赛事分类
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            选择你的竞技舞台
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            六大赛事类型，总有一款适合你。无论你是硬核玩家还是休闲爱好者，都能在这里找到属于自己的挑战。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-accent-300/60 hover:bg-background-100 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-950 mb-2 group-hover:text-accent-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 mb-4 leading-relaxed">
                {cat.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-500">{cat.articleCount} 篇攻略</span>
                <span className="text-accent-600 text-sm group-hover:translate-x-1 transition-transform whitespace-nowrap">
                  查看赛事 <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}